import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
//UI
const Navbar = React.lazy(() => import('./components/Navbar'));
const Notice = React.lazy(() => import('./components/Notice'));
const ContactUs = React.lazy(() => import('../../components/contactus/ContactUs'));
const Footer = React.lazy(() => import('./components/Footer'));
import MainLoader from '../../components/Loaders/MainLoader.jsx';
//SLICE
import { getScreenAdminThunk, initialStatePage } from '../../store/slices/pages/page.slice.jsx';
import { getYachtsThunk, initialStateYacht } from '../../store/slices/catalogs/yacht.slice.jsx';
import { getNoticeThunk, initialStateNotice } from '../../store/slices/pages/noitcesAdmin.slice.jsx';
import { scrollToTop } from '../../utils/funtions.js';

const NoticePage = () => {

  const dispatch = useDispatch();
  const yachtState = useSelector(state => state.yachts);
  const blogState = useSelector(state => state.page);

  const noticeState = useSelector(state => state.noticesAdmin);
  const isLoading = useSelector(state => state.isLoadingSlice);
  const { blog } = useParams();

  useEffect(() => {
    scrollToTop();
    dispatch(getScreenAdminThunk('galapagos-blog'));
    dispatch(getYachtsThunk())
    return () => {
      dispatch(initialStateYacht());
      dispatch(initialStatePage());
    }
  }, []);


  useEffect(() => {
    dispatch(getNoticeThunk(blog));
    return () => {
      dispatch(initialStateNotice());
    }
  }, [blog]);

  return (
    <div className='bg-white'>
      {
        isLoading || noticeState.fetching || yachtState.fetching ? <MainLoader /> :
          <>
            <Navbar yachtState={yachtState.yachts} />
            <Notice
              blogsState={blogState.page}
              noticeState={noticeState.notice}
            />
            <ContactUs />
            <Footer />
          </>
      }
    </div>
  );
};

export default NoticePage;